import React from 'react';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcConfItem from 'components/molecules/PcConfItem';

import './index.pc.scss';

const PresentPC = ({
  confList,

  onClickMainButton,
  showLoading,
  isApiError,
}) => (
  <div className="Conf">
    <PcBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      showLoading={showLoading}
    >
      {confList.map((conf)=>{
        const { text, children, questionMark, isCloseState, popUpTitle, popUpDetail } = conf;
        if(isCloseState) return '';
        return(
          <PcConfItem
            text={text}
            questionMark={questionMark}
            key={text}
            popUpTitle={popUpTitle}
            popUpDetail={popUpDetail}
          >
            {children}
          </PcConfItem>
        );
      })}
    </PcBasicTemplate>
  </div>
);

export default PresentPC;